import { schema } from 'normalizr';

const headlinesSchema = new schema.Entity('headlines');

export default {
  headlinesSchema,
};
